import React, { forwardRef, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import * as icons from 'react-bootstrap-icons';
import CButton from 'Utils/Helpers/CButton';
import { HandleVibrate } from 'Utils/Helpers/HandleApiData';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function PatientShow({name, nCode, mobile, uniCode}) {
  const [show, setShow] = useState(false);
  const setShowDialog = () => {
    setShow(true);
  }
  const handleClose= () => {
    setShow(false);
  }
  const onMouseUp = (e) => {
    HandleVibrate();
  }
  return (
    <>
      <div className='dy-title' onClick={setShowDialog} onMouseUp={onMouseUp}>
          <p className='ms-1'>{name}</p>
          <icons.EyeFill />
      </div>
      {
        show &&
        <Dialog
          open={show}
          TransitionComponent={Transition}
          keepMounted
          fullWidth={true}
          maxWidth={'xs'}
          onClose={handleClose}
          aria-describedby="alert-dialog-slide-appointment-edit"
        >
          <DialogTitle className=''>
            {"اطلاعات بیمار"}
            <div className='close-btn' onClick={handleClose}>
              <icons.X/>
            </div>
          </DialogTitle>
          <DialogContent>
            <div className='delete-body'>
              <div className='content'>
                <p>
                  {'مشخصات بیمار :'}
                </p>
                <div className='details'>
                  <p>
                    {"نام :"}
                    {" "}
                    <strong>{name}</strong>
                  </p>
                  <p>
                    {"کد ملی :"}
                    {" "}
                    <strong>{nCode}</strong>
                  </p>
                  <p>
                    {"شماره پرونده :"}
                    {" "}
                    <strong>{uniCode}</strong>
                  </p>
                  <p>
                    {"موبایل :"}
                    {" "}
                    <strong>{mobile}</strong>
                  </p>
                </div>
              </div>
            </div>
          </DialogContent>
          <DialogActions>
            <CButton
              text={'مطلع شدم'}
              icon={<icons.CheckLg/>}
              onClick={handleClose}
            />
          </DialogActions>
        </Dialog>
      }
    </>
  );
}
